export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['Main Menu']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'My Record',
        to: 'MyRecord',
        icon: {
          src: require('@/assets/img/folder-open.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Apply',
        route: '/ApplyLeave',
        icon: {
          src: require('@/assets/img/folder-add.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Leave',
            to: 'ApplyLeave',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Claim',
            to: 'ApplyClaim',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Time Off',
            to: 'ApplyTimeOff',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Salary',
            to: 'ApplySalary',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Announcement',
        to: 'Announcement',
        icon: {
          src: require('@/assets/img/volume-high.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Calendar',
        to: 'TeamCalendar',
        icon: {
          src: require('@/assets/img/calendar 2.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Performance',
        to: 'Performance',
        icon: {
          src: require('@/assets/img/chart.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Profile Setting',
        to: 'SettingProfile',
        icon: {
          src: require('@/assets/img/user-tick.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]